export const EthnicityType = { BLACK: 'Black', WHITE: 'White', COLOURED: 'Coloured', INDIAN: 'Indian/Asian', OTHER: 'Other/Unspecified' };
